import { render } from "./ItemCuentaCliente.vue?vue&type=template&id=7f1add99&scoped=true"
import script from "./ItemCuentaCliente.vue?vue&type=script&lang=js"
export * from "./ItemCuentaCliente.vue?vue&type=script&lang=js"

import "./ItemCuentaCliente.vue?vue&type=style&index=0&id=7f1add99&scoped=true&lang=scss"

import exportComponent from "/home/cubel/PhpstormProjects/failder/vue-failder/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f1add99"]])

export default __exports__